// extracted by mini-css-extract-plugin
export default {"container":"S05_container__c+m81","limiter":"S05_limiter__9HDUv","products":"S05_products__1GNzY","precautions":"S05_precautions__EGdi5"};